import * as React from 'react';

import { CloseSmall, Email, PlusBig } from '../../icons';
import { IconButton, RectangleButton } from '../buttons';
import { DropdownInput } from '../drop-down-inputs';
import { Input } from '../inputs';
import { LinkComponent } from '../link-component';
import { Text, TinyText } from '../texts';
import { Styled } from './styled';

// eslint-disable-next-line max-len
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const emailValidator = (value: string): string  =>
  !value || !EMAIL_REGEX.test(value) ? 'Invalid email address' : undefined;

interface RoleData {
  id: number;
  name: string;
}

interface Props {
  onFormSubmit: (formsData: Array<{ email: string, role: RoleData }>) => void;
  userLimit?: number;
  userRoles: RoleData[];
  title: string;
  buttonTitle: string;
  ButtonIcon?: any;
}

export const AddCompanyUserPopup = React.memo<Props>((props) => {
  const { onFormSubmit, userLimit, userRoles, title, buttonTitle, ButtonIcon } = props;
  const cleanForm = { email: undefined, role: userRoles[userRoles.length - 1] };
  const [formsData, setFormsData] = React.useState([cleanForm]);
  const [formsCount, setFormsCount] = React.useState(1);
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const moreClick = () => {
    setFormsData([...formsData, cleanForm]);
    setFormsCount(formsCount + 1);
  };
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const shareClick = () => onFormSubmit(formsData);
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onEmailChange = (index, value) => {
    const newFormsData = [...formsData];
    newFormsData[index].email = value;
    setFormsData(newFormsData);
  };
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onRoleChange = (index, value) => {
    const newFormsData = [...formsData];
    newFormsData[index].role = value;
    setFormsData(newFormsData);
  };
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const deleteForm = index => setFormsData(formsData.filter((_form, i) => i !== index));
  const buttonsDisabled = formsData.some(form => emailValidator(form.email));
  const canAddUser = !userLimit || userLimit > formsData.length;
  return (
    <Styled.Container>
      <Text>{title}</Text>
      {formsData.map((formData, index) =>
        (<Styled.Form key={index}>
          <Input
            width={'330px'}
            type="text"
            text={'Email'}
            input={{
              value: formData.email,
              onChange: e => onEmailChange(index, e.target.value),
            }}
            icon={<Email />}
          />
          <Styled.DropdownContainer>
            <DropdownInput
              header={'Role'}
              elements={userRoles.map(x => x.name)}
              activeElementIndex={userRoles.indexOf(formData.role)}
              // eslint-disable-next-line react/jsx-no-bind
              onClick={i => onRoleChange(index, userRoles[i])}
              closeAfterClick={true}
            />
          </Styled.DropdownContainer>
          {formData.email !== undefined && <TinyText color={'red'}>{emailValidator(formData.email)}</TinyText>}
          {index !== 0 &&
            <IconButton
              Icon={CloseSmall}
              height={30}
              iconHeight={10}
              // eslint-disable-next-line react/jsx-no-bind
              onClick={() => deleteForm(index)}
            />
          }
        </Styled.Form>),
      )}
      {canAddUser && (
        <LinkComponent
          text={'More'}
          Icon={PlusBig}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={moreClick}
          mood={buttonsDisabled && 'disabled'}
        />
      )}
      <RectangleButton
        Icon={ButtonIcon}
        mood={buttonsDisabled ? 'disabled' : 'secondary'}
        text={buttonTitle}
        width={165}
        // eslint-disable-next-line react/jsx-no-bind
        height={60} onClick={shareClick}
      />
    </Styled.Container>
  );
},
);
